import api from "../../../core/api";
import {
  ProgressUpdate,
  ServiceCompletionDetails,
  RequestRevisionRequest,
  ConfirmCompletionResponse,
} from "../models/executionModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

class ServiceExecutionApi {
  getProgressUpdates(serviceRequestId: string): Promise<ProgressUpdate[]> {
    return api
      .get<ProgressUpdate[]>(
        `/v1/customer/service-requests/${serviceRequestId}/execution/progress`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  getCompletion(serviceRequestId: string): Promise<ServiceCompletionDetails> {
    return api
      .get<ServiceCompletionDetails>(
        `/v1/customer/service-requests/${serviceRequestId}/execution/completion`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  confirmCompletion(serviceRequestId: string): Promise<ConfirmCompletionResponse> {
    return api
      .post<ConfirmCompletionResponse>(
        `/v1/customer/service-requests/${serviceRequestId}/execution/confirm-completion`,
        null,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  requestRevision(
    serviceRequestId: string,
    data: RequestRevisionRequest
  ): Promise<void> {
    return api
      .post(
        `/v1/customer/service-requests/${serviceRequestId}/execution/request-revision`,
        data,
        getRequestConfig()
      )
      .then(() => {});
  }

  getCompletionFiles(
    serviceRequestId: string
  ): Promise<Array<{ name: string; content: string; size: number }>> {
    return api
      .get<Array<{ name: string; content: string; size: number }>>(
        `/v1/customer/service-requests/${serviceRequestId}/execution/completion/files`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }
}

export default new ServiceExecutionApi();
